<template>
  <div v-if="cbtUnlicensedError" id="testTotalling_slide" class="p-test-detail">
    <div class="c-table-no-data">
      <p class="c-parts-text-alert">
        <span class="u-text-bold">{{ cbtUnlicensedError }}</span>
      </p>
    </div>
  </div>
  <div v-else id="testTotalling_slide" class="p-test-detail">
    <p>集計・分析の条件を選択してください。</p>
    <div class="p-test-form-wrapper">
      <dl class="p-test-form__list">
        <dt class="p-test-form__subtitle -center">年度</dt>
        <dd class="p-test-form__contents">
          <div class="c-form-select -status jsSelectBox p-test-form__half-select">
            <div class="output" data-unique_id="academic_session_year">
              <input type="hidden" name="academic_session_year" :value="selectedAcademicSession?.value">
              <div class="label">{{ selectedAcademicSession?.name }}</div>
              <div class="arrow"></div>
            </div>
            <div class="option">
              <ul class="option__list">
                <li
                  v-for="academic_session in cbtYearClasses?.academic_sessions"
                  :key="academic_session.value"
                  :data-select-value="academic_session.value"
                  :data-is-selected="academic_session.value === selectedAcademicSession?.value ? 'selected' : undefined"
                  @click="changeAcademicSession(academic_session)"
                >
                  <span class="label">{{ academic_session.name }}</span>
                </li>
              </ul>
            </div>
          </div>
        </dd>
      </dl>
      <dl class="p-test-form__list">
        <dt class="p-test-form__subtitle -center">学年</dt>
        <dd class="p-test-form__contents">
          <div class="c-form-radio-area">
            <label
              v-for="[academicYear, has_license] in academicYearsForRendering"
              :key="academicYear.value"
              class="c-form-radio"
              :class="{ '-disabled': !selectedAcademicSession || !has_license }"
              :for="'grade2' + academicYear.value"
            >
              <input
                type="radio"
                name="grade2"
                :value="academicYear.value"
                :id="'grade2' + academicYear.value"
                class="c-form-radio__input"
                :checked="selectedAcademicYear === academicYear"
                :disabled="!selectedAcademicSession || !has_license"
                @change="changeAcademicYear(academicYear)"
              >
              <span class="c-form-radio__label">{{ academicYear.name }}生</span>
            </label>
          </div>
        </dd>
      </dl>
      <dl class="p-test-form__list">
        <dt class="p-test-form__subtitle -center">学級</dt>
        <dd class="p-test-form__contents">
          <!--
            jsSelectBox は、一般的な select, option のプルダウンではなく、div, ul で構築されているため、disabled では無効化することはできない。
            生徒登録・生徒編集で jsSelectBox を無効化している実装を参考に、pointer-events と background-color を指定することで無効化は実現している。
          -->
          <div
            class="c-form-select -status jsSelectBox p-test-form__half-select"
            :style="!selectedAcademicYear ? { 'pointer-events': 'none' } : {}"
          >
            <div
              class="output"
              data-unique_id="class"
              :style="!selectedAcademicYear ? { 'background-color': '#f1f3f4' } : {}"
            >
              <input type="hidden" name="classroom" :value="selectedClassroom?.value">
              <div class="label">{{ selectedClassroom?.name }}</div>
              <div class="arrow"></div>
            </div>
            <div class="option">
              <ul class="option__list">
                <li
                  v-for="classroom in classrooms"
                  :key="classroom.value"
                  :data-select-value="classroom.value"
                  :data-is-selected="classroom.value === selectedClassroom?.value ? 'selected' : undefined"
                  @click="changeClassroom(classroom)"
                >
                  <span class="label">{{ classroom.name }}</span>
                </li>
              </ul>
            </div>
          </div>
        </dd>
      </dl>
      <dl class="p-test-form__list">
        <dt class="p-test-form__subtitle">教科</dt>
        <dd class="p-test-form__contents">
          <div class="c-form-radio-area">
            <label
              v-for="subjectField in subjectFieldsForRendering"
              :key="subjectField.id"
              class="c-form-radio"
              :class="{ '-disabled': !selectedAcademicYear || !subjectField.has_license }"
              :for="'subject2' + subjectField.id"
            >
              <input
                type="radio"
                name="subject2"
                :value="subjectField.id"
                :id="'subject2' + subjectField.id"
                class="c-form-radio__input"
                :checked="selectedSubjectField === subjectField"
                :disabled="!selectedAcademicYear || !subjectField.has_license"
                @change="changeSubjectField(subjectField)"
              >
              <span class="c-form-radio__label">{{ subjectField.name }}</span>
            </label>
          </div>
        </dd>
      </dl>
      <dl class="p-test-form__list">
        <dt class="p-test-form__subtitle -center">項目</dt>
        <dd class="p-test-form__contents">
          <!--
            jsSelectBox は、一般的な select, option のプルダウンではなく、div, ul で構築されているため、disabled では無効化することはできない。
            生徒登録・生徒編集で jsSelectBox を無効化している実装を参考に、pointer-events と background-color を指定することで無効化は実現している。
          -->
          <div
            class="c-form-select -status jsSelectBox"
            :style="!selectedSubjectField ? { 'pointer-events': 'none' } : {}"
          >
            <div
              class="output"
              data-unique_id="test"
              :style="!selectedSubjectField ? { 'background-color': '#f1f3f4' } : {}"
            >
              <input type="hidden" name="cbt_unit" :value="selectedCbtUnit?.id">
              <div class="label">
                <plain-text-view v-if="selectedCbtUnit" :markdownText="selectedCbtUnit.title"/>
              </div>
              <div class="arrow"></div>
            </div>
            <div class="option">
              <ul class="option__list">
                <li
                  v-for="cbt_unit in cbtUnits?.cbt_units"
                  :key="cbt_unit.id"
                  :data-select-value="cbt_unit.id"
                  :data-is-selected="cbt_unit.id === selectedCbtUnit?.id ? 'selected' : undefined"
                  @click="changeCbtUnit(cbt_unit)"
                >
                  <span class="label">
                    <plain-text-view :markdownText="cbt_unit.title"/>
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </dd>
      </dl>
    </div>
    <div class="c-button -center">
      <a
        target="_blank"
        class="c-button-blue -small-no-icon -type02"
        v-bind="reportResultsButtonAttrs"
      >
        <span class="label">集計結果を表示</span>
      </a>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { ref, computed, onMounted, watch } from "vue";
  import { useCbtStore } from "@/store/teacher/cbt_store";
  import {
    ICbtYearClassSelectOptions,
    ISelectSingleOption,
    ICbtSubjectFieldSelectOption,
    ICbtUnitsData,
    ICbtUnit,
  } from "@/consts/interfaces";

  const cbtStore = useCbtStore();
  // 先生の学校にCBT教材ライセンスがないエラー
  const cbtUnlicensedError = ref<string>("");

  // 「年度」「学年」「学級」の選択肢
  const cbtYearClasses = ref<ICbtYearClassSelectOptions | null>(null);
  // 「教科」の選択肢
  const cbtSubjectFields = ref<ICbtSubjectFieldSelectOption[] | null>(null);
  // 「項目」の選択肢
  const cbtUnits = ref<ICbtUnitsData | null>(null);

  // 各フィールドで選択中の値
  const selectedAcademicSession = ref<ISelectSingleOption | null>(null);
  const selectedAcademicYear = ref<ISelectSingleOption | null>(null);
  const selectedClassroom = ref<ISelectSingleOption | null>(null);
  const selectedSubjectField = ref<ICbtSubjectFieldSelectOption | null>(null);
  const selectedCbtUnit = ref<ICbtUnit | null>(null);

  // クエリパラメータからの初期値が適用済みかどうかのフラグ（初回のみ適用し、以降の watch 発火時はスキップする）
  let subjectFieldParamApplied = false;
  let cbtUnitParamApplied = false;

  onMounted(async () => {
    // 「年度」「学年」「学級」の選択肢を取得
    const cbtYearClassResponse: any = await cbtStore.fetchCbtYearClass() ?? null;

    if ("E005" === cbtYearClassResponse?.code) {
      // エラー、かつ、404 (有効なCBT教材のライセンスがありません) の場合
      cbtUnlicensedError.value = cbtYearClassResponse.title;
      return;
    }
    cbtYearClasses.value = cbtYearClassResponse;

    // FIXME: 有効なライセンスが無かったとき（fetchCbtYearClass でエラーレスポンスが返ってきたとき）に
    // ブランクページを表示するパターンは、NFR-6802 で考慮する（「実施状況」の NFR-6673 の対応が参考になるかも）

    // クエリパラメータに「年度」「学年」が存在する場合は、その値を初期値としてセット
    // クエリパラメータが存在しない場合は、「年度」は降順で取得されたもののうち、先頭の最新年度を初期値としてセット
    const params = getInitialQueryParams();
    if (params?.academic_session_id) {
      selectedAcademicSession.value = cbtYearClasses.value?.academic_sessions.find(x => x.value === Number(params.academic_session_id)) ?? null;
    } else if (cbtYearClasses.value?.academic_sessions.length > 0) {
      selectedAcademicSession.value = cbtYearClasses.value.academic_sessions[0];
    }
    if (params?.academic_year) {
      selectedAcademicYear.value = academicYears.value.find(x => x.value === Number(params.academic_year)) ?? null;
    }
  });

  // 「学年」「学級」の選択肢は、選択中の値に応じて、算出プロパティで取得する
  const academicYears = computed(() => {
    // 「学年」の選択肢が取得されていない、または「年度」が未選択の場合は、空の配列を返す
    if (!cbtYearClasses.value || !selectedAcademicSession.value) {
      return [];
    }
    // 選択中の「年度」に対応する学年一覧を返す
    // もし対応する学年一覧が存在しない場合は、空の配列を返す
    return cbtYearClasses.value.academic_years[selectedAcademicSession.value.value] ?? [];
  });
  const classrooms = computed(() => {
    // 「学級」の選択肢が取得されていない、または「年度」か「学年」が未選択の場合は、空の配列を返す
    if (!cbtYearClasses.value || !selectedAcademicSession.value || !selectedAcademicYear.value) {
      return [];
    }
    // 選択中の「年度」「学年」に対応する学級一覧を返す
    // もし対応する学級一覧が存在しない場合は、空の配列を返す
    return cbtYearClasses.value.classrooms[selectedAcademicSession.value.value]?.[selectedAcademicYear.value.value] ?? [];
  });

  // 「年度」「学年」の選択肢が変更されたときに「教科」の選択肢を更新
  watch([selectedAcademicSession, selectedAcademicYear], async () => {
    // 「年度」「学年」のいずれかが未選択の場合は、「教科」の選択肢はクリアする
    if (!selectedAcademicSession.value || !selectedAcademicYear.value) {
      cbtSubjectFields.value = null;
      return;
    }
    // 「年度」「学年」のすべてが選択中の場合は、「教科」の選択肢を取得
    cbtSubjectFields.value = await cbtStore.fetchCbtSubjectFields(
      {
        academic_session_id: Number(selectedAcademicSession.value.value),
        academic_year: Number(selectedAcademicYear.value.value),
      }
    ) ?? null;

    // クエリパラメータに「教科」が存在する場合は、その値を初期値としてセット
    if (!subjectFieldParamApplied) {
      const params = getInitialQueryParams();
      if (params?.subject_field_id) {
        selectedSubjectField.value = cbtSubjectFields.value?.find(x => x.id === Number(params.subject_field_id)) ?? null;
      }
      subjectFieldParamApplied = true;
    }
  });

  // 「年度」「学年」「教科」の選択肢が変更されたときに「項目」の選択肢を更新
  watch([selectedAcademicSession, selectedAcademicYear, selectedSubjectField], async () => {
    // 「年度」「学年」「教科」のいずれかが未選択の場合は、「項目」の選択肢はクリアする
    if (!selectedAcademicSession.value || !selectedAcademicYear.value || !selectedSubjectField.value) {
      cbtUnits.value = null;
      return;
    }
    // 「年度」「学年」「教科」のすべてが選択中の場合は、「項目」の選択肢を取得
    cbtUnits.value = await cbtStore.fetchCbtUnits(
      {
        academic_session_id: Number(selectedAcademicSession.value.value),
        academic_year: Number(selectedAcademicYear.value.value),
        subject_field_id: Number(selectedSubjectField.value.id),
      }
    ) ?? null;

    // クエリパラメータに「項目」が存在する場合は、その値を初期値としてセット
    if (!cbtUnitParamApplied) {
      const params = getInitialQueryParams();
      if (params?.cbt_unit_id) {
        selectedCbtUnit.value = cbtUnits.value?.cbt_units.find(x => x.id === Number(params.cbt_unit_id)) ?? null;
      }
      cbtUnitParamApplied = true;
    }
  });

  // 「学年」「教科」の選択肢は、以下の算出プロパティで変換された v-for レンダリング用の変数を利用する
  //
  // FIXME: 「教科」の選択肢は、T15-1「開始・終了・返却」タブの既存APIを使いまわしたことにより、
  // 検索画面ではAPIレスポンスがそのまま使えず、レンダリング用の変数に変換するアドホックな実装となってしまっています。
  // 必要なら、検索画面用の選択肢の取得は別APIに分けるなどの見直しを検討してください。
  //
  // 「学年」の選択肢は、学校種別に応じた全学年に対して、
  // ライセンスが存在するかどうかのフラグを tuple 形式で持たせるようにする
  // * ライセンスがある学年 -> フラグは true
  // * ライセンスがない学年 -> フラグは false
  const academicYearsForRendering = computed(() =>
    (cbtYearClasses.value?.all_academic_years_by_school_type ?? []).map(academicYear => {
      const option = academicYears.value.find(
        opt => opt.value === academicYear.value
      );
      return option ? [option, true] : [academicYear, false];
    })
  );
  // 「教科」の選択肢は、まだAPIで受け取っていないときは、全教科ライセンスなしのデフォルト値が使われるようにする
  const subjectFieldsForRendering = computed(() => {
    if (cbtSubjectFields.value) {
      return cbtSubjectFields.value;
    }

    // 「教科」の選択肢のデフォルト値（全教科ライセンスなし）
    // * 「年度」「学年」が選択されて、APIで選択肢が取得されるまでは、全教科が disabled で表示されるように、has_license はすべて false としておく
    // * 実際にDBから取得した値ではないので、id にも仮の値の 0 をセットしておく
    // * ログイン中の先生の学校種別に応じて、デフォルトの教科を出し分ける
    const defaultSubjectFields = cbtYearClasses.value?.school_type_code === 1
      ? ["国語", "算数", "理科", "社会", "英語"]
      : ["国語", "地理", "歴史", "公民", "数学", "理科", "英語"];

    return defaultSubjectFields.map(
      subject_field => ({"id": 0, "name": subject_field, "has_license": false})
    );
  });

  // 各フィールドの選択時のイベントハンドラ
  function changeAcademicSession(academicSession: ISelectSingleOption) {
    selectedAcademicSession.value = academicSession;
    // 「年度」を変更した場合、「学年」「学級」「教科」「項目」で選択中の値はリセット
    selectedAcademicYear.value = null;
    selectedClassroom.value = null;
    selectedSubjectField.value = null;
    selectedCbtUnit.value = null;
  }
  function changeAcademicYear(academicYear: ISelectSingleOption) {
    selectedAcademicYear.value = academicYear;
    // 「学年」を変更した場合、「学級」「教科」「項目」で選択中の値はリセット
    selectedClassroom.value = null;
    selectedSubjectField.value = null;
    selectedCbtUnit.value = null;
  }
  function changeClassroom(classroom: ISelectSingleOption) {
    selectedClassroom.value = classroom;
  }
  function changeSubjectField(subjectField: ICbtSubjectFieldSelectOption) {
    selectedSubjectField.value = subjectField;
    // 「教科」を変更した場合、「項目」で選択中の値はリセット
    selectedCbtUnit.value = null;
  }
  function changeCbtUnit(cbtUnit: ICbtUnit) {
    selectedCbtUnit.value = cbtUnit;
  }

  // クエリパラメーターを正規化するユーティリティ関数
  const normalizeQueryParam = (x: string | null): string | null => x && x.trim() !== "" ? x : null;

  // 実施状況タブの「成績」リンクから渡されたクエリパラメーターを取得する
  function getInitialQueryParams() {
    const params = new URLSearchParams(window.location.search);
    return {
      academic_session_id: normalizeQueryParam(params.get("academic_session_id")),
      academic_year: normalizeQueryParam(params.get("academic_year")),
      subject_field_id: normalizeQueryParam(params.get("subject_field_id")),
      cbt_unit_id: normalizeQueryParam(params.get("cbt_unit_id")),
    }
  }

  // 「集計結果を表示」ボタンの属性
  // すべてのフィールドが選択中の場合のみ、ボタンが有効となり、リンク先URLが設定される
  const reportResultsButtonAttrs = computed(() => {
    const allSelected = (
      selectedAcademicSession.value &&
      selectedAcademicYear.value &&
      selectedClassroom.value &&
      selectedSubjectField.value &&
      selectedCbtUnit.value
    );
    if (!allSelected) return {class: {'-disabled': true}};

    const params = new URLSearchParams({
      academic_session_id: String(selectedAcademicSession.value.value),
      academic_year: String(selectedAcademicYear.value.value),
      classroom: String(selectedClassroom.value.value),
      subject_field_id: String(selectedSubjectField.value.id),
      cbt_unit_id: String(selectedCbtUnit.value.id),
    });
    return {href: `/teacher/cbt/report/results/?${params.toString()}`};
  });
</script>

<style scoped>
</style>
